import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';

/**
 * @description Sets any manual flags
 * @param searchParams URLSearchParams
 */
export const setManualFlags = (searchParams: URLSearchParams): void => {
  if (searchParams.get(searchFilterKeysMap.alternateResults) !== 'false')
    searchParams.set(searchFilterKeysMap.alternateResults, 'true');
};
